import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.334 7.942a3 3 0 0 0-1.063-2.29L8.425 1.55a1 1 0 0 0-1.183 0L2.396 5.651a3 3 0 0 0-1.062 2.29v5.843a1 1 0 0 0 1 1h2.333a1 1 0 0 0 1-1v-3.667a1 1 0 0 1 1-1H9a1 1 0 0 1 1 1v3.666a1 1 0 0 0 1 1h2.333a1 1 0 0 0 1-1z"
    }, null, -1)
  ]))]))
}
export default { render: render }